import React from 'react';
import { cn } from '../lib/utils';

interface AvatarFrameProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export default function AvatarFrame({ children, className, size = 'md' }: AvatarFrameProps) {
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32'
  };

  return (
    <div className={cn("relative inline-block", sizeClasses[size], className)}>
      <div className={cn(
        "w-full h-full rounded-2xl overflow-hidden bg-slate-800 shadow-inner relative z-10",
        "border-2 border-slate-700/50"
      )}>
        <div className="w-full h-full">
          {children}
        </div>
        
        {/* Subtle inner shadow for depth */}
        <div className="absolute inset-0 pointer-events-none shadow-[inset_0_4px_12px_rgba(0,0,0,0.4)] rounded-inherit" />
      </div>
    </div>
  );
}
